import { UpdateAddressResponse } from "library/api/address/types.generated";
import { ResidentialFormValues } from "../../types";
import { Actions, ActionTypes, ApiData, InternalState } from "./types";

const getMailingStatus = (
  apiData: UpdateAddressResponse,
  formValues: ResidentialFormValues,
): ApiData["mailing"]["status"] => {
  if (formValues?.mailingAddressIsTheSame === "no") {
    return "NOT_REQUIRED";
  }
  return apiData.mailing_same_as_residential === true ? "success" : "failure";
};

const handleSuccess = (
  apiData: UpdateAddressResponse,
  formValues: ResidentialFormValues,
): InternalState => ({
  status: "SUCCESS",
  payload: {
    residential: {
      status: apiData.status,
      address: apiData.address,
    },
    mailing: {
      status: getMailingStatus(apiData, formValues),
    },
  },
});

export const reducer = (
  state: InternalState,
  actions: Actions,
): InternalState => {
  switch (actions.type) {
    case ActionTypes.SUBMIT_2FA_REQUIRED: {
      const { createSessionUrl, token } = actions.payload;
      if (!createSessionUrl || !token) {
        return {
          status: "ERROR",
          error: "Either createSessionUrl or token is missing from the api",
        };
      }
      return {
        status: "2FA_REQUIRED",
        createSessionUrl,
        token,
      };
    }
    case ActionTypes.LOAD_WITH_2AF_RENEWED: {
      return { status: "IDLE" };
    }

    case ActionTypes.SUBMIT_SUCCESS: {
      const {
        payload: { apiData, formValues },
      } = actions;

      return handleSuccess(apiData, formValues);
    }

    case ActionTypes.SUBMIT_ISSUES: {
      const {
        payload: { apiError, formValues },
      } = actions;

      const { payload: apiPayload } = apiError;

      /**
       * 🚨 Api might give 400 and it can be because residential was successful but mailing failed.
       * We should still show the success page if that's the case and show inline error for mailing.
       */
      if (apiPayload?.status === "success") {
        return handleSuccess(apiPayload, formValues);
      }

      return {
        status: "ERROR",
        error: apiError,
      };
    }
    case ActionTypes.SUBMIT_ERROR: {
      const {
        payload: { apiError },
      } = actions;

      return {
        status: "ERROR",
        error: apiError,
      };
    }

    default:
      return state;
  }
};
